import { useEffect, useState } from 'react';
import { render } from '@testing-library/react';
const baseRanks = require('./ranks.json');


function Gallery() {

  const [currentPage, setCurrentPage] = useState(0);
  const [pricesArray, setPricesArray] = useState(Array(25).fill('N/A'));

  const DisplayImages = () => {
    const idArray = Array.from(Array(25).keys()).map(index => (
        index + currentPage * 25
    ))

    return idArray.map(image => (
        <div key={image.toString()}>
            <img id="img1" style={{width: "100%", objectFit: "cover", imageRendering: "pixelated"}} src={`${process.env.PUBLIC_URL}/original/${image}.png`} loading="lazy" alt = "loading"></img>
            <div style={{textAlign: "center"}}>Splicer #{image}</div>
            <div style={{textAlign: "center"}}>Rank: {baseRanks[image]}</div>
            <div style={{textAlign: "center"}}>Price: {pricesArray[image]}</div>
        </div>
      
    ))
  }

  const NextPage = () => {
    setCurrentPage(current => current + 1);
  }

  const PrevPage = () => {
    if (currentPage === 0) return;
    setCurrentPage(current => current - 1);
  }

  useEffect(() => {      
    Array.from(Array(25).keys()).map(index => (        
        GetPrice(index + currentPage * 25)
    ))
  }, [currentPage])

  const GetPrice = (id) => {
    fetch(`https://api.opensea.io/api/v1/asset/0xfD4BfE64fea2ce11898c4b931AFAF728778a90b4/${id}/?include_orders=true`)
    .then(res => res.json())
    .then((data) => {
        if (data["orders"].length === 0) return "N/A";
        data["orders"].forEach(element => {
            console.log(element["current_price"], element["side"]);
            if (element["side"] === 1)
            {
                let tempPrices = pricesArray;
                tempPrices[id] = (element["current_price"] / 1000000000000000000).toString();
                setPricesArray(tempPrices);
            }
        });
    })
  }

  return (
    <div>
        <button onClick={PrevPage}>Prev Page</button>
        <span>Page {currentPage + 1}</span>
        <button onClick={NextPage}>Next Page</button>
        <div className="gallery">
            <DisplayImages />
        </div>        
    </div>
  )
}

export default Gallery;
